export default __webpack_public_path__ + "static/media/dots.9c7c988c.svg";